var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUnlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.143,
    height: 13.186,
    viewBox: "0 0 10.143 13.186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-unlock",
    "data-name": "Icon ionic-ios-unlock",
    d: "M15.625,7.939H9.666V6.418a2.155,2.155,0,0,1,4.311,0h0a.444.444,0,1,0,.888,0h0a3.043,3.043,0,1,0-6.086.041v1.48H8.018A1.272,1.272,0,0,0,6.75,9.207v6.086a1.272,1.272,0,0,0,1.268,1.268h7.607a1.272,1.272,0,0,0,1.268-1.268V9.207A1.272,1.272,0,0,0,15.625,7.939Zm-3.36,3.956v2.181a.455.455,0,0,1-.422.456.444.444,0,0,1-.466-.444V11.895a1.014,1.014,0,1,1,.888,0Z",
    transform: "translate(-6.75 -3.374)",
    fill: "#666"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlock);
export default __webpack_public_path__ + "static/media/icon-unlock.e62b4b9b18f40efaf0b72b3b4146afb4.svg";
export { ForwardRef as ReactComponent };